import * as React from 'react';
const styles = {
  allText: {
    MozUserSelect: 'text',
    WebkitUserSelect: 'text',
    msUserSelect: 'text',
    userSelect: 'text',
  },
};

export interface TEllipsisTextProps {
  text: any;
  length: any;
  tail?: string;
  tailclassname?: string;
  // channelCode: string;
}

class EllipsisText extends React.Component<TEllipsisTextProps, any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  public render() {
    let { tail, tailclassname } = this.props;
    const { text, length, ...others } = this.props;

    // delete others.channelCode;

    if (!tail) {
      tail = '...';
    }
    if (!tailclassname) {
      tailclassname = 'more';
    }

    if ((text && text.length <= this.props.length) || this.props.length < 0) {
      // if (this.props.channelCode && this.props.channelCode === "IPG") {
      // 	return ( <span {...others}>{this.props.text} | <span className="footer-bold">ASSET</span>MARK </span> );
      // } else {
      return <span {...others}>{this.props.text}</span>;
      // }
    } else {
      const tailStyle = {
        cursor: 'auto',
      };

      const displayText =
        length - tail.length <= 0
          ? ''
          : text
          ? text.slice(0, length - tail.length)
          : '';

      return (
        <span title={this.props.text} {...others}>
          {displayText}
          <span style={tailStyle} className={tailclassname}>
            {tail}
          </span>
        </span>
      );
    }
  }
}

export default EllipsisText;
